import { render, staticRenderFns } from "./_SelectedPanel.vue?vue&type=template&id=567b5095&"
import script from "./_SelectedPanel.vue?vue&type=script&lang=js&"
export * from "./_SelectedPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports